import { styled } from 'twin.macro';
import { RadioGroupProps } from '.';
import { getStylesFromProps } from '../../core/utils';

export default styled.div<RadioGroupProps>`
    ${(props) => getStylesFromProps(props)};
`;
